import { ReactComponent as Logo } from 'assets/logo/svg/droplla-logo.svg';
import { Box, useToken } from '@chakra-ui/react';

const DropllaLogo = ({ colorKey = 'droplla.500', ...props }) => {
  // Use Chakra UI's color token
  const [color] = useToken('colors', [colorKey]);

  return (
    <Box
      as={Logo}
      style={{ fill: color }}
      
      {...props}
    />
  );
};

export default DropllaLogo;
